<div class="margin">
  <panel heading="{{systemTitle}}">
          <div class="system-overview">
              <ng-container *ngIf="systemType === 1">
                  <ng-container *ngIf="FamilyImage_Chain != null">
                      <overview-image size="140" [src]="getImage(imageUrl)" [loading]="loadingSystem"></overview-image>
                  </ng-container>
                  <ng-container *ngIf="FamilyImage_Chain == null">
                      <overview-image size="140" src="{{imageUrl}}" [loading]="loadingSystem"></overview-image>
                  </ng-container>
              </ng-container>
              <ng-container *ngIf="systemType === 2">
                  <ng-container *ngIf="FamilyImage_Frame != null">
                      <overview-image size="140" [src]="getImage(imageUrl)" [loading]="loadingSystem"></overview-image>
                  </ng-container>
                  <ng-container *ngIf="FamilyImage_Frame == null">
                      <overview-image size="140" src="{{imageUrl}}" [loading]="loadingSystem"></overview-image>
                  </ng-container>
              </ng-container>

            <div class="system-overview__content">
              <div class="content__primary">
                <item-group>
                  <item [label]="'Serial Number' | translate | async" [primary]="true" [loading]="loadingSystem">{{system?.SystemSerialNumber}}</item>

                </item-group>
                <div  class="content__primary-buttons"  *ngIf="!loadingSystem"  [@fadeInList] >
                 <div title="{{'Only one action can be performed' | translate | async}}" *ngIf="actionLocked && ( selectedActionAgainstSystem?.SystemId !== system?.SystemId)">
                      <mat-icon aria="unlock">lock</mat-icon>
                  </div> 
                  <div *ngIf="(!actionLocked &&  selectedActionAgainstSystem === undefined ) || selectedActionAgainstSystem?.SystemId === system?.SystemId ">
                    <button class="systemActionButton mat-raised-button {{selectedAction?.ActionTypeId === action.ActionTypeId ? 'mat-warn': ''}} "  *ngFor="let action of systemActions"  (click)="selectActionOnSystem(action)" >
                          {{ action.ActionTypeName | translate | async  }}
                        </button> 
                    <!-- <button  [matMenuTriggerFor]="actionsSelectionOnSystem" mat-raised-button color="grey">
                      System Actions
                    </button> -->
                     <!-- Just did this for now, should implement a action description -->
                    <!-- <mat-menu #actionsSelectionOnSystem="matMenu">
                        <button mat-menu-item *ngFor="let action of system?.SystemAvailableActions" (click)="selectActionOnSystem(action)">{{"Replace from Inventory" | translate | async}}</button>
                    </mat-menu> -->
                  </div>

                </div>
              </div>
            </div>
          </div>

         
    <div *ngIf="system?.Components?.length == 0"> {{"There is no components on this system, please make sure your undercarriage setup correctly " | translate | async}} </div>

    <div class="table-container" *ngIf="system?.Components?.length > 0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Brand' | translate | async}}</th>
            <th>{{'Position' | translate | async}}</th>
            <th>{{'Eval' | translate | async}}</th>
            <th>{{'Current CMU' | translate | async}}</th>
            <th>{{'Actions' | translate | async}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of system?.Components">
            <td class="component-cell">
              <div class="component-photo-container">
                <img class="component-photo" [src]="getImage(c.ComponentImage)" />
              </div>
            </td>
            <td>
              <span title="{{c.Name}}">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}} </span>
            </td>
            <td>{{c.Brand}}</td>
            <td>{{c.Position}}</td>
            <td class="table__eval-cell">
              <span style="width: 80px;" class="Eval-{{c.Worn | wornPercentageToEval }}">
                <div style=" text-align: center !important ; display: inline-block;">{{ c.Worn | wornPercentageToEval }}</div>
              </span>
            </td>
            <td>{{c.Cmu}}</td>
            <td>
                <div (click)="unlock()" title="{{'Only one action can be performed' | translate | async}}" *ngIf="(actionLocked || selectedActionAgainstSystem!== undefined ) && selectedActionAgainstComponent?.GeneralEqunitId !== c.GeneralEqunitId ">
                  <mat-icon aria="unlock">lock</mat-icon>
                </div>
                <div *ngIf="!actionLocked || ( selectedActionAgainstComponent !== undefined &&  selectedActionAgainstComponent?.GeneralEqunitId === c.GeneralEqunitId)  ">
                  <button  [matMenuTriggerFor]="actionsSelection" mat-raised-button color="grey">
                    {{selectedAction === undefined ? 'Component Actions' : selectedAction.ActionTypeName }}
                  </button>
                <mat-menu #actionsSelection="matMenu">
                    <button mat-menu-item *ngFor="let action of c.ComponentAvailableActions" (click)="selectActionOnComponent(action, c)">{{action.ActionTypeName}}</button>
                </mat-menu>
              </div>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</div>
